import getFeatureCounts from 'api/v2/users/getFeatureCounts';
import { useQuery } from 'react-query';
import { UserCacheKeys } from 'types/cacheKeys.types';
import { getStoredAuthData } from 'utils/auth';

const useFeatureCounts = () =>
  useQuery([UserCacheKeys.FeatureCounts], getFeatureCounts, {
    cacheTime: 0,
    staleTime: 0,
    enabled: !!getStoredAuthData('access_token'),
  });

export default useFeatureCounts;
